module.exports = __webpack_public_path__ + "img/en_1.13cdd289.jpg";